import {
    CLEAR_ANALYZE_REPORT, ERROR_ANALYZE_REPORT,
    FETCH_ANALYZE_REPORT,
    LIST_ANALYZE_REPORT
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    data: {},
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_ANALYZE_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_ANALYZE_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
                ...payload.paging
            };
        case ERROR_ANALYZE_REPORT:
            return {
                ...state,
                isLoading: false
            };
        case CLEAR_ANALYZE_REPORT:
            return {
                ...init
            };
        default:
            return state;
    }
}
